class TSMainProduct extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.querySelector("#TSProductForm");
    this.productMessage = this.productForm.querySelector("#TSFormMessage");
    this.mainSliderElement = this.querySelector("#TSMainSlider");
    this.media = this.mainSliderElement.querySelectorAll('.ts-product__media img');
    this.thumbSliderElement = this.querySelector("#TSThumbSlider");
    this.lightboxElement = this.querySelector("#TSLightbox");
    this.mainSlider;
    this.thumbSlider;
    this.lightboxSlider;
    this.cart = document.querySelector("ts-cart");
    this.isLoading = false;
    this.contactForm = this.querySelector('.ts-invoice-form');

    this.initSlider();
    this.initClickEvents();
    this.initSubmitEvents();
    this.initForm();
    this.setupVariantSelector();
    this.initStickyCart();

    this.querySelectorAll('[data-trigger="disclosure"].open').forEach(disclosure => {
      const disclosureContent = disclosure.nextElementSibling;
      disclosureContent.style.maxHeight = disclosureContent.scrollHeight + "px";
    })

    this.querySelectorAll('.ts-show-more').forEach((button) => {
      let maxHeight = 240;
      const disclosure = button.closest('.ts-product-info__description');
      if (window.matchMedia("(max-width: 744px)").matches) {
        maxHeight = 340;
      }
      if (disclosure.scrollHeight < maxHeight) {
        button.style.dispaly = 'none';
      }

      button.addEventListener('click', () => {
        if (disclosure.classList.contains('open')) {
          disclosure.style.maxHeight = maxHeight + 'px';
          disclosure.style.paddingBottom = 0;
        } else {
          disclosure.style.maxHeight = disclosure.scrollHeight + 80 + 'px';
          disclosure.style.paddingBottom = 80 + 'px';
        }
        disclosure?.classList.toggle('open');
      })
    })

    document.addEventListener("keydown", (e) => {
      if (this.lightboxSlider && this.lightboxElement.classList.contains("open")) {
        if (e.key === "ArrowLeft") {
          this.lightboxSlider.previous();
        } else if (e.key === "ArrowRight") {
          this.lightboxSlider.next();
        }
      }
    });
  }

  initSlider() {
    if (this.mainSliderElement?.querySelector("[data-slider]")) {
      this.mainSlider = new Flickity(this.mainSliderElement.querySelector("[data-slider]"), {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true
      });
    }

    if (this.thumbSliderElement?.querySelector("[data-slider]")) {
      this.thumbSlider = new Flickity(this.thumbSliderElement.querySelector("[data-slider]"), {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true
      });

      this.thumbSlider.on('staticClick', (event, pointer, cellElement, cellIndex) => {
        if (!cellElement) return;
        this.mainSlider.select(cellIndex)
      });
      this.mainSlider.on('change', (index) => { this.thumbSlider.select(index) });
    }

    if (this.lightboxElement?.querySelector("[data-lightbox-slider]")) {
      this.lightboxSlider = new Flickity(this.lightboxElement.querySelector("[data-lightbox-slider]"), {
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: false
      });
      this.lightboxSlider.on('change', (index) => {
        this.lightboxElement.querySelector(".ts-lightbox__thumbnail-item.active").classList.remove("active");
        this.lightboxElement.querySelector(`.ts-lightbox__thumbnail-item[data-slide="${index + 1}"]`).classList.add("active");
      });
    }
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        switch (e.target.dataset.trigger) {
          case "lightbox-change":
            this.lightboxSlider.select(parseInt(e.target.dataset.slide) - 1);
            if (this.querySelector("#TSLightboxHeader")) {
              this.querySelector("#TSLightboxHeader").innerText = e.target.dataset.slide + " of " + this.lightboxSlider.slides.length;
            }
            break;
          case "lightbox-prev":
            this.lightboxSlider.previous();
            break;
          case "lightbox-next":
            this.lightboxSlider.next();
            break;
          case "lightbox-close":
            this.lightboxElement.classList.remove("open");
            break;
          case "lightbox-open":
            if (this.lightboxSlider) {
              this.lightboxSlider.select(parseInt(e.target.dataset.slide) - 1);
              this.querySelector("#TSLightboxHeader").innerText = e.target.dataset.slide + " of " + this.lightboxSlider.slides.length;
            }
            this.lightboxElement.classList.add("open");
            break;
          case "previous-slide":
            if (this.mainSlider) this.mainSlider.previous();
            break;
          case "next-slide":
            if (this.mainSlider) this.mainSlider.next();
            break;
          case "video":
            const videoBlock = e.target;
            const video = e.target.querySelector("video");

            videoBlock.classList.toggle("play");
            if (videoBlock.classList.contains("play")) {
              video.play();
            } else {
              video.pause();
            }
            break;
          case "disclosure":
            const disclosureContent = e.target.nextElementSibling;
            e.target.classList.toggle("open");
            disclosureContent.style.maxHeight = e.target.classList.contains("open") ? disclosureContent.scrollHeight + "px" : null;
            break;
          case "form":
            this.toggleForm();
            break;
          default:
            break;
        }
      }
    })
  }

  initForm() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("contact_posted") === "true") {
      this.toggleForm();
    }
  }

  toggleForm() {
    this.contactForm.classList.toggle('open');
    if (this.contactForm.classList.contains('open')) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
    }
  }

  initSubmitEvents() {
    this.productForm.addEventListener("submit", (e) => {
      e.preventDefault();
      if (!this.isLoading) this.addToCart();
    })
  }

  setupVariantSelector() {
    const optionInputs = this.querySelectorAll('.ts-options input[type="radio"]');
    const productIdInput = this.querySelector('input[name="id"]');

    if (!productIdInput) return;
    const variantDataScript = this.querySelector('#ProductVariants');
    if (!variantDataScript) return;
    const variants = JSON.parse(variantDataScript.textContent);

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.updateVariant(productIdInput, variants);
      });
    });
  }

  updateVariant(productIdInput, variants) {
    const selectedOptions = [];

    this.querySelectorAll('.ts-options fieldset').forEach((fieldset) => {
      const selectedInput = fieldset.querySelector('input:checked');
      if (selectedInput) {
        selectedOptions.push(selectedInput.value);
      }
    });

    const matchedVariant = variants.find((variant) =>
      variant.options.every((opt, index) => opt === selectedOptions[index])
    );

    if (matchedVariant.featured_image) {
      const matchedUrl = new URL(matchedVariant.featured_image.src, window.location.origin);

      Array.from(this.media).forEach((img, index) => {
        const imgUrl = new URL(img.src);
        if (imgUrl.pathname === matchedUrl.pathname) {
          this.mainSlider.select(index)
        }
      });
    }

    if (matchedVariant) {
      productIdInput.value = matchedVariant.id;
    }
  }

  addToCart() {
    this.toggleLoading();

    const sections = [];
    if (this.cart) sections.push("ts-cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(this.productForm.querySelector("[name='id']").value),
          quantity: parseInt(this.productForm.querySelector("[name='quantity']").value)
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
      .then(response => response.json())
      .then(response => {
        if (!response.items) {
          let error = new Error(response.description);
          throw error;
        } else {
          if (this.productMessage) this.productMessage.innerHTML = "";

          if (this.cart) {
            this.cart.renderContent(response.sections);
            this.cart.open();
          } else {
            window.location.pathname = '/cart';
          }

        }
      }).catch((error) => {
        if (this.productMessage) {
          this.productMessage.innerHTML = error;
          setTimeout(() => { this.productMessage.innerHTML = '' }, 5000);
        }
        console.error(error);
      })
      .finally(() => {
        this.toggleLoading();
      })
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.remove("loading", this.isLoading);
    
    // Sync sticky cart button loading state
    const stickyButton = document.querySelector('#StickyProductSubmit');
    const mainButton = this.querySelector('#TSProductSubmit');
    if (stickyButton && mainButton) {
      if (this.isLoading) {
        stickyButton.classList.add('loading');
        stickyButton.disabled = true;
      } else {
        stickyButton.classList.remove('loading');
        stickyButton.disabled = false;
      }
    }
  }

  initStickyCart() {
    const productForm = this.productForm;
    const stickyCart = document.querySelector('.sticky-add-to-cart');
    const stickyButton = document.querySelector('#StickyProductSubmit');
    const cartDrawer = document.querySelector('ts-cart');
    
    if (!productForm) {
      console.warn('Sticky cart: Product form not found');
      return;
    }
    
    if (!stickyCart) {
      console.warn('Sticky cart: Sticky cart element not found');
      return;
    }
    
    if (!stickyButton) {
      console.warn('Sticky cart: Sticky button not found');
      return;
    }

    // Track form visibility state
    let isFormVisible = true;
    let isCartDrawerOpen = false;

    // Function to show/hide sticky cart based on all conditions
    const updateStickyCartVisibility = () => {
      if (isCartDrawerOpen) {
        // Always hide when cart drawer is open
        stickyCart.classList.remove('show');
        document.body.classList.remove('sticky-add-to-cart--active');
      } else if (!isFormVisible) {
        // Show when form is not visible and drawer is closed
        stickyCart.classList.add('show');
        document.body.classList.add('sticky-add-to-cart--active');
      } else {
        // Hide when form is visible
        stickyCart.classList.remove('show');
        document.body.classList.remove('sticky-add-to-cart--active');
      }
    };

    // Update sticky cart price and variant when variant changes
    const updateStickyCartContent = () => {
      const variantIdInput = productForm.querySelector('input[name="id"]');
      const priceElement = stickyCart.querySelector('.sticky-add-to-cart__price--original');
      const comparePriceElement = stickyCart.querySelector('.sticky-add-to-cart__price--compare');
      const variantDataScript = this.querySelector('#ProductVariants');
      
      // Get price from the main form's price display
      const mainPriceElement = this.querySelector('.ts-product__price');
      if (mainPriceElement) {
        const mainPriceOriginal = mainPriceElement.querySelector('.ts-product__price--original');
        const mainPriceCompare = mainPriceElement.querySelector('.ts-product__price--compare');
        
        if (mainPriceOriginal && priceElement) {
          priceElement.textContent = mainPriceOriginal.textContent.trim();
        }
        
        if (mainPriceCompare && comparePriceElement) {
          comparePriceElement.textContent = mainPriceCompare.textContent.trim();
          // Check if compare price is visible (not display:none or hidden)
          const compareStyle = window.getComputedStyle(mainPriceCompare);
          comparePriceElement.style.display = (compareStyle.display !== 'none' && mainPriceCompare.offsetParent !== null) ? 'inline' : 'none';
        } else if (comparePriceElement) {
          comparePriceElement.style.display = 'none';
        }
      }
      
      // Update button state based on variant availability
      if (variantIdInput && variantDataScript) {
        try {
          const variants = JSON.parse(variantDataScript.textContent);
          const currentVariant = variants.find(v => v.id === parseInt(variantIdInput.value));
          
          if (currentVariant) {
            // Find the first text span (not icon or loading)
            const buttonText = Array.from(stickyButton.querySelectorAll('span')).find(
              span => !span.classList.contains('ts-icon') && !span.classList.contains('ts-product__loading')
            );
            if (currentVariant.available === false) {
              stickyButton.classList.add('disabled');
              stickyButton.disabled = true;
              if (buttonText) buttonText.textContent = 'Uitverkocht';
            } else {
              stickyButton.classList.remove('disabled');
              stickyButton.disabled = false;
              if (buttonText) buttonText.textContent = 'Toevoegen';
            }
          }
        } catch (error) {
          console.error('Error updating sticky cart content:', error);
        }
      }
    };

    // Use Intersection Observer to detect when form is out of view
    const observerOptions = {
      root: null,
      rootMargin: '-100px 0px 0px 0px', // Account for sticky cart height
      threshold: 0
    };

    const handleIntersection = (entries) => {
      entries.forEach(entry => {
        isFormVisible = entry.isIntersecting;
        updateStickyCartVisibility();
      });
    };

    // Check if IntersectionObserver is supported
    if (typeof IntersectionObserver !== 'undefined') {
      const observer = new IntersectionObserver(handleIntersection, observerOptions);
      observer.observe(productForm);
    } else {
      // Fallback for browsers without IntersectionObserver support
      console.warn('IntersectionObserver not supported, sticky cart may not work correctly');
    }

    // Watch for cart drawer open/close
    if (cartDrawer) {
      const cartDrawerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            isCartDrawerOpen = cartDrawer.classList.contains('open');
            updateStickyCartVisibility();
          }
        });
      });

      cartDrawerObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
      });

      // Initial check
      isCartDrawerOpen = cartDrawer.classList.contains('open');
    }

    // Handle sticky button click
    stickyButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (!this.isLoading && !stickyButton.classList.contains('disabled')) {
        // Trigger form submit
        this.addToCart();
      }
    });

    // Update sticky cart image when variant changes
    const updateStickyCartImage = () => {
      const variantIdInput = productForm.querySelector('input[name="id"]');
      const stickyImage = stickyCart.querySelector('.sticky-add-to-cart__image');
      const variantDataScript = this.querySelector('#ProductVariants');
      
      if (variantIdInput && variantDataScript && stickyImage) {
        try {
          const variants = JSON.parse(variantDataScript.textContent);
          const currentVariant = variants.find(v => v.id === parseInt(variantIdInput.value));
          
          if (currentVariant && currentVariant.featured_image) {
            const imageUrl = new URL(currentVariant.featured_image.src, window.location.origin);
            imageUrl.searchParams.set('width', '60');
            stickyImage.src = imageUrl.toString();
            const productTitle = this.querySelector('.ts-product__title');
            stickyImage.alt = currentVariant.featured_image.alt || (productTitle ? productTitle.textContent : '') || '';
          }
        } catch (error) {
          console.error('Error updating sticky cart image:', error);
        }
      }
    };

    // Update sticky cart when variant changes
    const variantInputs = this.querySelectorAll('.ts-options input[type="radio"]');
    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        // Wait a bit for the price to update
        setTimeout(() => {
          updateStickyCartContent();
          updateStickyCartImage();
        }, 100);
      });
    });

    // Also listen for price updates (in case price is updated elsewhere)
    const priceObserver = new MutationObserver(() => {
      updateStickyCartContent();
    });

    const mainPriceElement = this.querySelector('.ts-product__price');
    if (mainPriceElement) {
      priceObserver.observe(mainPriceElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Initial update
    updateStickyCartContent();
    updateStickyCartImage();
    updateStickyCartVisibility();
  }
}

customElements.define("ts-product", TSMainProduct)

function swapOpacity(childrens) {
  childrens.map((elem) => elem.style.opacity == '0' ? elem.style.opacity = '1' : elem.style.opacity = '0');
}
const animationDiv = document.querySelector('.fade-animation-child');
if(animationDiv && animationDiv.children){
  const childrens = Array.from(animationDiv.children);
  setInterval(() => swapOpacity(childrens), 3000);
}